import React, {Component} from 'react';
import { connect } from 'react-redux';
import AllnewsContainer from "./containers/allnewscontainer.component";
import SliderAllNewsContainer from "./containers/sliderallnewscontainer.component";
import GroupedNews from "./groupednews.component";
import { getLastNewsFromAllCategories } from '../../../SHARED/actions/news.actions';
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import SearchByTag from '../../../SHARED/components/searchbytag/searchbytag.component';
import { Helmet } from 'react-helmet';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
class AllNews extends Component {

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.getLastNewsFromAllCategories();
    }

    componentDidMount() {
        pageViewEvent('Toate știrile - Cinemap',window.location.href);
    }

    getLatestNews = () => {
        return this.props.newsFromCategs.map((nw, i) => {
            return <GroupedNews nw={nw} key={i}/>
        });
    };

    render() {
        return (
            <div className="all-news pt-2">
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <Helmet>
                    <title>Toate știrile - Cinemap</title>
                    <meta name='description' content='Știri legate de filme, seriale, festivale, evenimente, cronici. Ultimele informații.'/>
                    <link rel='canonical' href={window.location.href}/>
                </Helmet>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            <SliderAllNewsContainer />
                            { this.getLatestNews() }
                        </div>
                        <div className="col-lg-3">
                            <AllnewsContainer />
                            <SearchByTag />
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    newsFromCategs: state.news.newsFromCategs
});
export default connect(mapStateToProps, {getLastNewsFromAllCategories})(AllNews);



// WEBPACK FOOTER //
// ./src/FO/components/news/allnews.component.js